<script lang="ts">
  const paths = [
    "M8 7.714 18.286 18 8 28.286",
    "M18.286 7.714 28.57 18 18.287 28.286",
    "M29.714 7.714 40 18 29.714 28.286",
  ]
</script>

<svg
  viewBox="0 0 49 36"
  stroke="currentColor"
  stroke-linecap="round"
  fill="none"
  stroke-width="3"
  xmlns="http://www.w3.org/2000/svg"
  {...$$props}
>
  {#each paths as path}
    <path d={path} />
  {/each}
</svg>

<style lang="postcss">
  path {
    animation: 1.2s infinite blink;

    &:nth-child(1) {
      animation-delay: 0s;
    }
    &:nth-child(2) {
      animation-delay: 0.15s;
    }
    &:nth-child(3) {
      animation-delay: 0.3s;
    }
  }

  @keyframes blink {
    0%,
    100% {
      opacity: 0.1;
      animation-timing-function: ease-in;
    }
    40% {
      opacity: 1;
      animation-timing-function: ease-out;
    }
  }
</style>
